export default function(state = {}, action) {
  const typeMap = {
    SUPERTAGS_LOADING() {
      return {
        isLoading: true,
        supertags: action.supertags
      };
    },
    SUPERTAGS_LOADED() {
      return {
        isLoading: false,
        supertags: action.supertags
      };
    },
    SUPERTAGS_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.supertags.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
